import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { ProductInfoModel } from './product-info.model';
import { ProductInfoService } from './product-info.service';

@Injectable({
  providedIn: 'root'
})
export class ProductInfoGuard implements CanActivate {

  constructor(
    private productInfoService: ProductInfoService,
    private router: Router,
  ) {}

  public canActivate(next: ActivatedRouteSnapshot,
                     state: RouterStateSnapshot): Observable<boolean> {
    return this.productInfoService.getBySerial(next.params['id']).pipe(
      switchMap((data: ProductInfoModel) => {
        if (data.isSoldToCustomer && data.salesOrganization) {
          if (next.params['id'] && next.params['salesOrganization'] && next.params['language']) {
            return of(true);
          } else {
            this.router.navigate(
              ['product-information', data.salesOrganization, data.language, next.params['id']]
            );
            return of(true);
          }
        } else {
          this.router.navigate(['product-information/not-sold', next.params['id']], { queryParams: next.queryParams });
          return of(false);
        }
      }),
      catchError(() => {
        this.router.navigate(['product-information/not-found', next.params['id']], { queryParams: next.queryParams });
        return of(false);
      })
    );
  }
}
